import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable react-hooks/exhaustive-deps */
import { Icon } from '@livable/saas-react-components';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import BillTable from 'src/pages/ResidentProfilePage/Bills/Statament/billTable';
import { useStore } from 'src/stores';
import { monthNames } from 'src/utils/date';
import useStatamentStyles from './styles';
const Statament = observer(props => {
  const classes = useStatamentStyles();
  const store = useStore();
  const additionalStataments = props.additionalStataments,
    propertyId = props.propertyId,
    residencyId = props.residencyId,
    setTriggerRefresh = props.setTriggerRefresh,
    statementId = props.statementId,
    userProfileData = props.userProfileData;
  const queue = store.allocations.queue;
  const statementData = store.statement.statementData(statementId);
  const statement = store.statement.accountStatementsPreview.find(j => j.statementId === statementId);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFetched = _useState2[0],
    setIsFetched = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isVoidedFetched = _useState6[0],
    setIsVoidedFetched = _useState6[1];
  const getAllocationTable = async data => {
    const resp = await store.allocations.getAllocationTableAggregateAsync.run(data);
    return resp;
  };
  const getStatement = async id => {
    const resp = await store.statement.getStatementAsync.run(id);
    return resp;
  };
  const getUtilityInfo = async ids => {
    if (!store.account.featureFlagsStore.getIsBillAutomationEnabled || !store.account.featureFlagsStore.getIsBillingTemplatesEnabled) {
      const resp = await store.utilityProviders.getUtilityInfoAsync.run({
        utilityIds: ids
      });
      return resp;
    } else {
      const resp = await store.utilityProviders.getPropertyUtilityInfoAsync.run({
        propertyId,
        utilityIds: ids
      });
      return resp;
    }
  };
  const getTransactionHistoryV2ListingAsync = async transactionIds => {
    const resp = await store.payment.getTransactionHistoryV2ListingAsync.run({
      transactionIds
    });
    return resp;
  };
  useEffect(() => {
    if (!isFetched && isOpen) {
      let ids = [];
      getStatement(statementId).then(async resp => {
        var _resp$response, _resp$response2;
        ids = [...(resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 || (_resp$response = _resp$response.statementCharges) === null || _resp$response === void 0 ? void 0 : _resp$response.items.map(i => i.utilityId).filter(i => i))];
        for (let count = 0; count < additionalStataments.length; count++) {
          // eslint-disable-next-line @typescript-eslint/no-loop-func
          await getStatement(additionalStataments[count]).then(response => {
            var _response$response;
            ids = [...ids, ...(response === null || response === void 0 || (_response$response = response.response) === null || _response$response === void 0 || (_response$response = _response$response.statementCharges) === null || _response$response === void 0 ? void 0 : _response$response.items.map(i => i.utilityId).filter(i => i))];
          });
        }
        const statementCreditsUtilityIds = resp === null || resp === void 0 || (_resp$response2 = resp.response) === null || _resp$response2 === void 0 || (_resp$response2 = _resp$response2.statementCredits) === null || _resp$response2 === void 0 ? void 0 : _resp$response2.items.map(i => {
          var _i$metadata;
          return (_i$metadata = i.metadata) === null || _i$metadata === void 0 ? void 0 : _i$metadata.utilityId;
        }).filter(i => i);
        ids = [...ids, ...statementCreditsUtilityIds];
      }).then(() => getUtilityInfo([...new Set(ids)])).finally(() => setIsFetched(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);
  useEffect(() => {
    if (!isVoidedFetched && statementData !== null && statementData !== void 0 && statementData.voidedTransactionIds.length) getTransactionHistoryV2ListingAsync(statementData.voidedTransactionIds).finally(() => setIsVoidedFetched(true));
  }, [statementData]);
  useEffect(() => {
    if (queue.length > 0 && !store.allocations.getAllocationTableAggregateAsync.inProgress) getAllocationTable({
      billingCycleId: queue[0].billingCycleId,
      propertyId,
      utilityId: queue[0].utilityId
    }).then(() => store.allocations.removeFromQueue(queue[0]));
  }, [queue]);
  const handleClick = () => setIsOpen(prevValue => !prevValue);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.allocation
  }, /*#__PURE__*/React.createElement(Accordion, {
    className: classes.accordion,
    expanded: isOpen
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "allocation-content",
    expandIcon: /*#__PURE__*/React.createElement(Icon, {
      state: "grey",
      fontSize: "large",
      type: "arrow-line-right"
    }),
    id: "allocation-header",
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "light",
    variant: "h5"
  }, monthNames[statement.month - 1].substring(0, 3), " ", statement.year), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, ': $', statement.total.toFixed(2))))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(BillTable, {
    isFinalStatement: statement.isFinalStatement,
    isVoided: statement.isVoided,
    propertyId: propertyId,
    residencyId: residencyId,
    setTriggerRefresh: setTriggerRefresh,
    statementData: statementData,
    userProfileData: userProfileData
  }), additionalStataments === null || additionalStataments === void 0 ? void 0 : additionalStataments.map(id => {
    const additionalStatament = store.statement.accountStatementsPreview.find(j => j.statementId === id);
    return /*#__PURE__*/React.createElement(BillTable, {
      key: id,
      isFinalStatement: additionalStatament.isFinalStatement,
      isVoided: additionalStatament.isVoided,
      propertyId: propertyId,
      residencyId: residencyId,
      setTriggerRefresh: setTriggerRefresh,
      statementData: store.statement.statementData(id),
      userProfileData: userProfileData
    });
  }))));
});
export default Statament;